export default __webpack_public_path__ + "static/japanese-4-1b0a92f244089426579d7c0c1696d411.png";